<div class="profile-container">
  <div class="">
    <!-- Listing View -->
    <div class="profile-content" *ngIf="!isAdd && !isRefresh">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <p>Formula List</p>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off">
                <input type="text" placeholder="search" name="listSearch" [(ngModel)]="listSearchQuery">
              </form>
              <i class="bi bi-search" (click)="onSearchChange()"></i>
            </div>
            <button *ngIf="actionControls.isAdd" (click)="add()"><i class="bi bi-plus-lg"></i> Add</button>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 25%">Formula Name</th>
              <th style="width: 25%">No. of Products</th>
              <th style="width: 25%">Total Amount</th>
              <th style="width: 25%;text-align: center;padding: 0;" class="">Action</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" (click)="onRowClick($event, product.productCompositionId)" *ngFor="let product of productCompositioncList | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count};let i = index">
            <p style="width: 25%">{{product.productName}}</p>
            <p style="width: 25%">{{product.productCompositionIngList.length}}</p>
            <p style="width: 25%">{{product.totalAmount}}</p>
            <p class="action-buttons" style="width: 25%;">
              <i *ngIf="product.isRefresh" class="bi bi-arrow-clockwise" (click)="refreshComposition(product.productCompositionId)"
                title="Refresh Composition"></i>

              <i *ngIf="actionControls.isView" class="bi bi-eye-fill"
                (click)="getProductCompositionById(product.productCompositionId)" data-toggle="modal"
                data-target="#exampleModalView"></i>

              <i *ngIf="actionControls.isModify" class="bi bi-pencil-square"
                (click)="editComposition(product.productCompositionId)"></i>

              <i *ngIf="actionControls.isDelete" class="bi bi-trash"
                (click)="deleteProduct(product.id,product.productCompositionId, product.productName)"
                data-toggle="modal" data-target="#deleteModal"></i>
            </p>
          </div>
        </div>

        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && productCompositioncList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>
        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}">
          </p-paginator>
        </div>
      </div>
    </div>

    <!-- Add/Edit Section -->
    <div class="profile-content" *ngIf="isAdd">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <p>{{isEdit ? 'Edit' : 'Add'}} Composition</p>
          </div>
          <div class="add-block">
            <button (click)="closeAdd()">Back</button>
          </div>
        </div>

        <div cdkDropListGroup class="composition-block">
          <!-- Left: Raw Materials -->
          <div class="example-container-left">
            <h2>Raw Material</h2>
            <input type="text" class="form-control" placeholder="search product" [(ngModel)]="searchBoxTxt"
              (ngModelChange)="filterProducts()">
            <hr>
            <div id="rawMaterialList" cdkDropList [cdkDropListData]="cProductListFilter" class="example-list1"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box1 d-flex justify-content-between align-items-center"
                *ngFor="let item of cProductListFilter; let i = index" cdkDrag>
                <div>
                  <div style="font-weight: 500;">{{item.code}}</div>
                  <small class="text-muted" *ngIf="item.uom">UOM: {{item.uom}} | Price: {{item.price}}</small>
                </div>
                <span style="cursor: pointer; color: #3899e8;" (click)="addItem(item, i)" title="Add item">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-plus-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <!-- Right: Composition Form -->
          <div class="example-container-right">
            <h2>Formula Name</h2>
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <input type="text" placeholder="enter formula name" [(ngModel)]="productName" class="form-control">
              </div>
              <div class="col-md-2 col-lg-2">
                <label for=""> Formula Quantity</label>
                <input type="number" min="0" placeholder="batch quantity" class="form-control"
                  [(ngModel)]="batchQuantity" (input)="enforcePositiveNumber($event)">
              </div>
              <div class="col-md-2 col-lg-2">
                <label for="">Formula Price</label>
                <input type="number" min="0" placeholder="batch price" class="form-control" [(ngModel)]="batchPrice"
                  (input)="enforcePositiveNumber($event)">
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="form-group">
                  <label for="">UOM</label>
                  <ng-multiselect-dropdown [placeholder]="'select uoms'" [settings]="uomDropdownSettings"
                    [data]="uomDropdownList" [(ngModel)]="uomSelectedList" class="form-control"
                    style="padding: 0;border: none">
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-md-4 col-lg-4" *ngIf="uomSelectedList.length != 0">
                <label for="">Default UOM</label>
                <select class="form-control" [(ngModel)]="isDefault">
                  <option value="" disabled selected hidden>-- select default uom --</option>
                  <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
                </select>
              </div>
            </div>

            <div id="doneList" cdkDropList [cdkDropListData]="done" class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let item of done;let i = index" cdkDrag>
                <div class="row input-data">
                  <div class="col-md-11 col-lg-11">
                    <p class="mb-2" style="font-weight: 500;">{{item.code}}</p>
                  </div>
                  <div class="col-md-1 col-lg-1 text-right">
                    <span style="cursor: pointer; color: #dc3545;" (click)="removeItem(item, i)" title="Remove item">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-trash" viewBox="0 0 16 16">
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3V2h11v1h-11Z" />
                      </svg>
                    </span>
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Price:</label>
                    <input type="text" readonly class="form-control" value="{{item.price}}">
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>UOM:</label>
                    <select class="form-control" (change)="uomChange($event,i)" [(ngModel)]="item.uom">
                      <option value="" disabled selected hidden>-- select uom --</option>
                      <option *ngFor="let uom of item.supportedUOM" [value]="uom.uomName">{{uom.uomName}}</option>
                    </select>
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Quantity:</label>
                    <input type="number" min="0" class="form-control" (keyup)="amountChanged()"
                      (input)="enforcePositiveNumber($event); amountChanged()" [(ngModel)]="item.qty">
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Sub Total:</label>
                    <input readonly type="text" class="form-control" value="{{item.price * item.qty}}">
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-footer">
              <p>Amount: {{amount}}</p>
              <div>
                <button class="add-b" (click)="save()">submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Refresh Section -->
    <div class="profile-content" *ngIf="isRefresh">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <p>Update Composition</p>
          </div>
          <div class="add-block">
            <button (click)="closeRefresh()">Back</button>
          </div>
        </div>

        <div cdkDropListGroup class="composition-block">
          <div class="example-container-right" style="width: 100%; max-width: none; margin: 0;">
            <h2>Formula Name</h2>
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <input type="text" placeholder="enter formula name" [(ngModel)]="productName" class="form-control">
              </div>
              <div class="col-md-2 col-lg-2">
                <label for=""> Formula Quantity</label>
                <input type="number" min="0" placeholder="batch quantity" class="form-control"
                  [(ngModel)]="batchQuantity" (input)="enforcePositiveNumber($event)">
              </div>
              <div class="col-md-2 col-lg-2">
                <label for="">Formula Price</label>
                <input type="number" min="0" placeholder="batch price" class="form-control" [(ngModel)]="batchPrice"
                  (input)="enforcePositiveNumber($event)">
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="form-group">
                  <label for="">UOM</label>
                  <ng-multiselect-dropdown [placeholder]="'select uoms'" [settings]="uomDropdownSettings"
                    [data]="uomDropdownList" [(ngModel)]="uomSelectedList" class="form-control"
                    style="padding: 0;border: none">
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-md-4 col-lg-4" *ngIf="uomSelectedList.length != 0">
                <label for="">Default UOM</label>
                <select class="form-control" [(ngModel)]="isDefault">
                  <option value="" disabled selected hidden>-- select default uom --</option>
                  <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
                </select>
              </div>
            </div>

            <div id="doneListRefresh" cdkDropList [cdkDropListData]="done" class="example-list"
              (cdkDropListDropped)="drop($event)">
              <div class="example-box" *ngFor="let item of done;let i = index" cdkDrag>
                <div class="row input-data">
                  <div class="col-md-11 col-lg-11">
                    <p class="mb-2" style="font-weight: 500;">{{item.name}}</p>
                  </div>

                  <div class="col-md-2 col-lg-2">
                    <label>Price:</label>
                    <input type="text" readonly class="form-control" value="{{item.price}}">
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Old Price:</label>
                    <input type="text" readonly class="form-control" value="{{item.oldPrice}}">
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <label>UOM:</label>
                    <select class="form-control" (change)="uomChange($event,i)" [(ngModel)]="item.uom">
                      <option value="" disabled selected hidden>-- select uom --</option>
                      <option *ngFor="let uom of item.supportedUOM" [value]="uom.uomName">{{uom.uomName}}</option>
                    </select>
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Quantity:</label>
                    <input type="number" min="0" class="form-control" (keyup)="amountChanged()"
                      (input)="enforcePositiveNumber($event); amountChanged()" [(ngModel)]="item.qty">
                  </div>
                  <div class="col-md-2 col-lg-2">
                    <label>Sub Total:</label>
                    <input readonly type="text" class="form-control" value="{{item.price * item.qty}}">
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-footer">
              <p>Amount: {{amount}}</p>
              <div>
                <button class="add-b" (click)="save()">submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- View Modal -->
<button type="button" id="openViewModalBtn" data-toggle="modal" data-target="#exampleModalView"
  style="display: none;"></button>
<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Product Composition
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let product of singleproductCompositionData">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Name</label>
                <input type="text" readonly value="{{product.productName}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Price</label>
                <input type="text" readonly value="{{product.batchPrice}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Quantity</label>
                <input type="text" readonly value="{{product.batchQuantity}}" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Total Amount</label>
                <input type="text" readonly value="{{product.totalAmount}}" class="form-control">
              </div>
            </div>
          </div>
          <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
            <thead>
              <tr>
                <th style="width: 60%;">Product</th>
                <th style="width: 10%;text-align: center;">Uom</th>
                <th style="width: 10%;text-align: center;">Quantity</th>
                <th style="width: 10%;text-align: center;">Price</th>
                <th style="width: 10%;text-align: center;">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let productCompositionIngList of product.productCompositionIngList;let i = index">
                <th>{{productCompositionIngList.code}}</th>
                <th style="text-align: center;">{{productCompositionIngList.uom}}</th>
                <th style="text-align: center;">{{productCompositionIngList.qty}}</th>
                <th style="text-align: center;">{{productCompositionIngList.price}}</th>
                <th style="text-align: center;">{{productCompositionIngList.price * productCompositionIngList.qty}}</th>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeView" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{productName}} (ID: {{deleteId}})”</span>?
        </p>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate
            }}</button>
          <button type="button" (click)="confirmDelete()" class="btn btn-primary" data-dismiss="modal">{{
            'generic.delete' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>